import React, { useState, useEffect, useCallback } from "react";

const ExitTimer = ({ duration = 30, onTimeUp, autoStart = true }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isRunning, setIsRunning] = useState(autoStart);

  const progressPercent = (timeLeft / duration) * 100;
  const isWarning = timeLeft <= 10;
  const isCritical = timeLeft <= 5;

  useEffect(() => {
    if (!isRunning || timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsRunning(false);
          onTimeUp();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isRunning, timeLeft, onTimeUp]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const getColor = () => {
    if (isCritical) return "#dc3545";
    if (isWarning) return "#f59e0b";
    return "#081da5";
  };

  const reset = useCallback(() => {
    setTimeLeft(duration);
    setIsRunning(true);
  }, [duration]);

  return (
    <div style={{ width: "100%" }}>
      {/* Timer Text */}
      <div
        className="d-flex align-items-center justify-content-between mb-2"
        style={{ fontSize: "14px", fontWeight: 600 }}
      >
        <span >Exit Without Saving</span>
        <span className="text-muted" style={{ fontSize: "12px" }}>
          {timeLeft}s
        </span>
      </div>

      {/* Progress Bar */}
      <div
        style={{
          width: "100%",
          height: "8px",
          backgroundColor: "#e5e7eb",
          borderRadius: "999px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progressPercent}%`,
            height: "100%",
            backgroundColor: getColor(),
            borderRadius: "999px",
            transition: "width 1s linear, background-color 0.3s",
          }}
        />
      </div>
    </div>
  );
};

export default ExitTimer;